import React, {useState} from 'react';

import useToggle from './useToggle';
import useOutsideClick from '@ibibo/use-outside-click';

const useSearchWidgetUI = () => {
  const calendarBlockRef = React.createRef();
  const paxWidgetBlockRef = React.createRef();

  const [calendarMode, setCalendarMode] = useState('');

  const [isPaxWidgetVisible, togglePaxWidgetVisible] = useToggle(false);

  const toggleCheckinCalendar = () => {
    if (calendarMode !== 'checkin') setCalendarMode('checkin');
    else setCalendarMode('');
  };

  const toggleCheckoutCalendar = () => {
    if (calendarMode !== 'checkout') setCalendarMode('checkout');
    else setCalendarMode('');
  };

  const closeCalendar = () => {
    setCalendarMode('');
  };

  const togglePaxWidget = val => {
    togglePaxWidgetVisible(val);
    if (val && isPaxWidgetVisible) closeCalendar();
  };

  useOutsideClick(calendarBlockRef, () => {
    setCalendarMode('');
  });

  useOutsideClick(paxWidgetBlockRef, () => {
    togglePaxWidget(false);
  });

  return {
    calendarBlockRef,
    paxWidgetBlockRef,
    calendarMode,
    toggleCheckinCalendar,
    toggleCheckoutCalendar,
    closeCalendar,
    setCalendarMode,
    isPaxWidgetVisible,
    togglePaxWidget,
  };
};

export default useSearchWidgetUI;
